import { render, staticRenderFns } from "./ForeignKeyField.vue?vue&type=template&id=4b980c02"
import script from "./ForeignKeyField.vue?vue&type=script&lang=js"
export * from "./ForeignKeyField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports